import React, { useState, useEffect, useRef } from 'react';
import whiteLogo from '../../images/navkar logo.png';
import coloredLogo from '../../images/navkar-logo-colored.png';
import { NavLink, useLocation } from 'react-router-dom';
import { FaInstagram, FaSearch, FaTimes, FaBars, FaChevronDown, FaTwitter, FaYoutube } from 'react-icons/fa';
import ProductSearchBar from 'components/common/ProductSearchBar ';
import { useGetAllProductsQuery } from 'api/productApi';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState({ main: false, products: false });
    const [isScrolled, setIsScrolled] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const { data: products = [], isLoading, isError } = useGetAllProductsQuery();

    const location = useLocation();
    const isLaminatesActive = ['/laminates'].some(path =>
        location.pathname.startsWith(path)
    );

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 300);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <>
            <header
                className={`fixed font-Montserrat font-semibold top-0 w-full z-[999] transition-all duration-300 ${
                    isScrolled
                        ? 'bg-white shadow-lg border-b border-gray-300'
                        : 'bg-transparent border-b border-black/30'
                }`}
            >
                <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-4 h-20 flex items-center justify-between transition-all duration-300">
                    <a href="/">
                        <img
                            src={isScrolled ? coloredLogo : whiteLogo}
                            className="w-32 h-auto max-h-16 object-contain transition-all duration-300"
                            alt="Navkar Logo"
                        />
                    </a>

                    <button
                        onClick={() => setMenuOpen(prev => ({ ...prev, main: !prev.main }))}
                        className={`md:hidden p-2 focus:outline-none transition-colors ${
                            isScrolled
                                ? 'text-gray-900 hover:text-[#92400e]'
                                : 'text-white hover:text-white/80'
                        }`}
                        aria-label="Toggle navigation menu"
                    >
                        {menuOpen.main ? <FaTimes className="text-2xl" /> : <FaBars className="text-2xl" />}
                    </button>

                    <nav className="hidden md:flex items-center px-2 space-x-3 lg:space-x-10">
                        <NavLink
                            to="/"
                            className={({ isActive }) =>
                                `${
                                    isActive
                                        ? 'text-primary font-semibold'
                                        : `${isScrolled ? 'text-black' : 'text-white'} hover:text-[#92400e]`
                                } nav-link-underline`
                            }
                        >
                            Home
                        </NavLink>

                        <NavLink
                            to="/about"
                            className={({ isActive }) =>
                                `${
                                    isActive
                                        ? 'text-primary font-semibold'
                                        : `${isScrolled ? 'text-black' : 'text-white'} hover:text-[#92400e]`
                                } nav-link-underline`
                            }
                        >
                            About
                        </NavLink>

                        {/* Laminates Dropdown */}
                        <div className="relative" ref={dropdownRef}>
                            <button
                                onClick={() => setDropdownOpen(prev => !prev)}
                                className={`flex items-center gap-1 ${
                                    isLaminatesActive
                                        ? 'text-[#92400e] font-semibold '
                                        : isScrolled
                                        ? 'text-black'
                                        : 'text-white'
                                } hover:text-[#92400e] focus:outline-none`}
                            >
                                Laminates
                                <FaChevronDown
                                    className={`transition-transform duration-300 ${
                                        dropdownOpen ? 'rotate-180' : ''
                                    } text-xs`}
                                />
                            </button>

                            {dropdownOpen && (
                                <div className="absolute left-0 top-full bg-white shadow-lg text-sm rounded-md mt-2 z-[999] min-w-[160px]">
                                    {[
                                        {
                                            to: '/laminates',
                                            label: 'Premium Laminates & Decoratives',
                                        },
                                        { to: '/acrylic', label: 'Acrylic' },
                                        { to: '/louvers', label: 'Louvers' },
                                    ].map(link => (
                                        <NavLink
                                            key={link.to}
                                            to={link.to}
                                            onClick={() => setDropdownOpen(false)}
                                            className="block px-4 py-2 text-black hover:bg-[#92400e] hover:text-white"
                                        >
                                            {link.label}
                                        </NavLink>
                                    ))}
                                </div>
                            )}
                        </div>

                        <NavLink
                            to="/events"
                            className={({ isActive }) =>
                                `${
                                    isActive
                                        ? 'text-primary font-semibold'
                                        : `${isScrolled ? 'text-black' : 'text-white'} hover:text-[#92400e]`
                                } nav-link-underline`
                            }
                        >
                            Events
                        </NavLink>

                        <NavLink
                            to="/blogs"
                            className={({ isActive }) =>
                                `${
                                    isActive
                                        ? 'text-primary font-semibold'
                                        : `${isScrolled ? 'text-black' : 'text-white'} hover:text-[#92400e]`
                                } nav-link-underline`
                            }
                        >
                            Blogs
                        </NavLink>

                        <NavLink
                            to="/contact"
                            className={({ isActive }) =>
                                `${
                                    isActive
                                        ? 'text-primary font-semibold'
                                        : `${isScrolled ? 'text-black' : 'text-white'} hover:text-[#92400e]`
                                } nav-link-underline`
                            }
                        >
                            Contact 
                        </NavLink>
                    </nav>

                    <div className="hidden md:flex lg:space-x-4 space-x-2 items-center">
                        <a
                            href="https://www.instagram.com/navkar_laminates_/"
                            aria-label="Instagram"
                            className="bg-[#814c26] w-10 h-10 flex items-center justify-center rounded-md"
                        >
                            <FaInstagram className="text-white text-lg" />
                        </a>
                        <a
                            href="/"
                            aria-label="Twitter"
                            className="bg-[#814c26] w-10 h-10 flex items-center justify-center rounded-md"
                        >
                            <FaTwitter className="text-white text-lg" />
                        </a>
                        <a
                            href="/"
                            aria-label="YouTube"
                            className="bg-[#814c26] w-10 h-10 flex items-center justify-center rounded-md"
                        >
                            <FaYoutube className="text-white text-lg" />
                        </a>
                        <button
                            onClick={() => setShowSearch(prev => !prev)}
                            aria-label="Search"
                            className={`${isScrolled ? 'text-black' : 'text-white'} hover:text-[#92400e]`}
                        >
                            <FaSearch className="text-lg" />
                        </button>
                    </div>
                </div>

                {menuOpen.main && (
                    <div className="absolute top-20 left-0 w-full bg-white/95 backdrop-blur-md px-4 sm:px-6 py-6 md:hidden z-[999] shadow-xl border-b border-gray-200 animate-fadeIn">
                        <div className="max-w-[1200px] mx-auto">
                            <nav className="flex flex-col space-y-2">
                                {[
                                    { to: '/', label: 'Home' },
                                    { to: '/about', label: 'About Us' },
                                    { to: '/events', label: 'Events' },
                                    { to: '/blogs', label: 'Blogs' },
                                    { to: '/contact', label: 'Contact Us' },
                                ].map((item) => (
                                    <NavLink
                                        key={item.to}
                                        onClick={() => setMenuOpen({ main: false, products: false })}
                                        to={item.to}
                                        className={({ isActive }) =>
                                            `px-4 py-2.5 rounded-lg text-base font-medium transition-all ${
                                                isActive
                                                    ? 'text-[#814c26] bg-[#814c26]/10 font-semibold'
                                                    : 'text-gray-800 hover:text-[#814c26] hover:bg-gray-50'
                                            }`
                                        }
                                    >
                                        {item.label}
                                    </NavLink>
                                ))}

                                <div className="px-4 py-2">
                                    <button
                                        onClick={() =>
                                            setMenuOpen(prev => ({
                                                ...prev,
                                                products: !prev.products,
                                            }))
                                        }
                                        className={`w-full flex items-center justify-between text-base font-medium transition-all ${
                                            isLaminatesActive ? 'text-[#814c26] font-semibold' : 'text-gray-800 hover:text-[#814c26]'
                                        }`}
                                    >
                                        <span>Laminates</span>
                                        <FaChevronDown
                                            className={`text-sm transition-transform duration-200 ${
                                                menuOpen.products ? 'rotate-180 text-[#814c26]' : 'text-gray-500'
                                            }`}
                                        />
                                    </button>
                                    {menuOpen.products && (
                                        <div className="ml-2 mt-2 space-y-1 pl-3 border-l-2 border-[#814c26]/30">
                                            {[
                                                {
                                                    to: '/laminates',
                                                    label: 'Premium Laminates & Decoratives',
                                                },
                                                { to: '/acrylic', label: 'Acrylic' },
                                                { to: '/louvers', label: 'Louvers' },
                                            ].map((link, index) => (
                                                <NavLink
                                                    key={index}
                                                    to={link.to}
                                                    onClick={() => setMenuOpen({ main: false, products: false })}
                                                    className={({ isActive }) =>
                                                        `block py-1.5 px-2 rounded text-sm transition-colors ${
                                                            isActive
                                                                ? 'text-[#814c26] font-semibold bg-[#814c26]/10'
                                                                : 'text-gray-700 hover:text-[#814c26]'
                                                        }`
                                                    }
                                                >
                                                    {link.label}
                                                </NavLink>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                <button
                                    onClick={() => {
                                        setShowSearch(true);
                                        setMenuOpen({ main: false, products: false });
                                    }}
                                    className="flex items-center gap-2 text-gray-800 hover:text-[#814c26] px-4 py-2.5 rounded-lg hover:bg-gray-50 font-medium transition-all"
                                >
                                    <FaSearch className="text-base text-[#814c26]" />
                                    <span>Search Products</span>
                                </button>
                            </nav>
                        </div>
                    </div>
                )}
            </header>

            {showSearch && !isLoading && !isError && (
                <div className="fixed top-0 left-0 w-full h-40 bg-white z-[999] flex items-start justify-center pt-16 px-4">
                    <div className="relative w-full max-w-xl">
                        <ProductSearchBar products={products} onClose={() => setShowSearch(false)} />
                        <button
                            className="absolute top-2 right-2 text-gray-600 hover:text-black text-xl"
                            onClick={() => setShowSearch(false)}
                        >
                            &#10005;
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default Header;
